(() => {
  if (!window.customElements || window.customElements.get('vg-detail-words')) return;

  class VillaGoDetailWords extends HTMLElement {
    constructor() {
      super();
      this.words = [];
      this.activeIndex = 0;
      this.timer = null;
      this.observer = null;
      this.motionPreference = null;
      this.visible = false;
      this.mounted = false;
      this.connectionVersion = 0;
      this.onVisibilityChange = () => this.syncAnimation();
      this.onMotionChange = () => this.syncAnimation();
    }

    connectedCallback() {
      if (this.mounted) return;
      this.mounted = true;
      const connectionVersion = ++this.connectionVersion;
      this.words = Array.from(this.children).filter((word) => word.classList.contains('vg-detail-word'));
      this.showWord(0);
      if (this.words.length < 2) return;

      this.motionPreference = typeof window.matchMedia === 'function'
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null;
      if (this.motionPreference?.addEventListener) {
        this.motionPreference.addEventListener('change', this.onMotionChange);
      } else if (this.motionPreference?.addListener) {
        this.motionPreference.addListener(this.onMotionChange);
      }
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.visible = false;
      if (typeof window.IntersectionObserver === 'function') {
        this.observer = new window.IntersectionObserver((entries) => {
          if (!this.mounted || connectionVersion !== this.connectionVersion) return;
          const entry = entries.find((candidate) => candidate.target === this);
          if (!entry) return;
          this.visible = entry.isIntersecting;
          this.syncAnimation();
        }, { threshold: 0 });
        this.observer.observe(this);
      }
      this.syncAnimation();
    }

    disconnectedCallback() {
      this.mounted = false;
      this.connectionVersion += 1;
      this.stopAnimation();
      this.observer?.disconnect();
      this.observer = null;
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      if (this.motionPreference?.removeEventListener) {
        this.motionPreference.removeEventListener('change', this.onMotionChange);
      } else if (this.motionPreference?.removeListener) {
        this.motionPreference.removeListener(this.onMotionChange);
      }
      this.motionPreference = null;
      this.visible = false;
    }

    canAnimate() {
      return this.mounted && this.words.length > 1 && this.visible
        && !document.hidden && !this.motionPreference?.matches;
    }

    syncAnimation() {
      if (this.motionPreference?.matches) this.showWord(0);
      if (!this.canAnimate()) {
        this.stopAnimation();
        return;
      }
      if (this.timer !== null) return;
      const connectionVersion = this.connectionVersion;
      this.timer = window.setInterval(() => {
        if (connectionVersion !== this.connectionVersion) return;
        if (!this.canAnimate()) {
          this.syncAnimation();
          return;
        }
        this.showWord((this.activeIndex + 1) % this.words.length);
      }, 3000);
    }

    showWord(index) {
      this.activeIndex = index;
      this.words.forEach((word, wordIndex) => word.classList.toggle('is-active', wordIndex === index));
    }

    stopAnimation() {
      if (this.timer === null) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  window.customElements.define('vg-detail-words', VillaGoDetailWords);
})();
